import { render } from "./BOrbisTable.vue?vue&type=template&id=f51581e8&scoped=true&ts=true"
import script from "./BOrbisTable.vue?vue&type=script&lang=ts"
export * from "./BOrbisTable.vue?vue&type=script&lang=ts"

import "./BOrbisTable.vue?vue&type=style&index=0&id=f51581e8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f51581e8"]])

export default __exports__